import { render, staticRenderFns } from "./BannerMasComodo.vue?vue&type=template&id=7dc9d920&scoped=true"
import script from "./BannerMasComodo.vue?vue&type=script&lang=js"
export * from "./BannerMasComodo.vue?vue&type=script&lang=js"
import style0 from "./BannerMasComodo.vue?vue&type=style&index=0&id=7dc9d920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc9d920",
  null
  
)

export default component.exports